<template>
  <div>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-light">{{ generateViewLevel(item.level) }}</span>
            </td>
          </template>
          <template #url="{ item }">
            <td v-if="item.url != null">
              <span class="view-file" @click="viewFile(item.url)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #videoUrl="{ item }">
            <td v-if="item.videoUrl">
              <span class="view-file" @click="viewFile(item.videoUrl)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CDropdown add-menu-classes="" add-toggler-classes="btn-outline-success"
                           color="transparent p-0" placement="bottom-end" style="min-width: 50px">
                  <template #toggler-content>
                    <CIcon name="cil-cloud-download"/>
                  </template>
                  <CDropdownItem :disabled="item.url == null || item.url == ''" @click="downloadFile(item.url)">Tệp tin
                    PDF
                  </CDropdownItem>
                  <CDropdownItem :disabled="item.videoUrl == null || item.videoUrl == ''"
                                 @click="downloadFile(item.videoUrl)">Tệp tin Video
                  </CDropdownItem>
                </CDropdown>
                <CButton class="ml-2"
                         color="danger"
                         variant="outline"
                         square
                         size="sm"
                         v-c-tooltip.hover="'Xóa'"
                         @click="setupSelectOneAction('delete_one', item.id, item.level)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CRow class="mt-4 content-fade-in mt-3p5" v-if="$hasAuthor('ROLE_ADMIN')">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <template v-for="each in fileManuals">
              <CRow>
                <CCol sm="12" md="12" xl="12" class="mt-4">
                  <b>{{ each.label }}</b>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <label class="form-label">{{ each.selectedFiles.options.label }}</label>
                    <div class="custom-file"
                         :class="each.selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                      <input type="file" class="custom-file-input" ref="file"
                             :accept="each.selectedFiles.options.accept" @change="selectFile($event, each.level, 0)">
                      <label class="custom-file-label">{{ each.selectedFiles.data.model.fileName }}
                        <i v-if="each.selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                           style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                      </label>
                    </div>
                    <div class="valid-error"
                         v-show="!(each.selectedFiles.data.validator ? each.selectedFiles.data.validator.isValid : true)">
                      {{ each.selectedFiles.data.validator ? each.selectedFiles.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <label class="form-label">{{ each.selectedFilesVideo.options.label }}</label>
                    <div class="custom-file"
                         :class="each.selectedFilesVideo.data.validator.isValid == false ? 'input-valid-error' : ''">
                      <input type="file" class="custom-file-input" ref="fileVideo"
                             :accept="each.selectedFilesVideo.options.accept"
                             @change="selectFile($event, each.level, 1)">
                      <label class="custom-file-label">{{ each.selectedFilesVideo.data.model.fileName }}
                        <i v-if="each.selectedFilesVideo.data.loading" class="fa fa-spinner fa-spin"
                           style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                      </label>
                    </div>
                    <div class="valid-error"
                         v-show="!(each.selectedFilesVideo.data.validator ? each.selectedFilesVideo.data.validator.isValid : true)">
                      {{
                        each.selectedFilesVideo.data.validator ? each.selectedFilesVideo.data.validator.errorMessage : ""
                      }}
                    </div>
                  </div>
                </CCol>
              </CRow>
            </template>
            <CRow>
              <CCol class="mt-3">
                <CButton color="primary" class="mr-2" @click="submitData()" :disabled="isDisableSubmit"><i
                  class="fa fa-check"></i>&nbsp;Đồng ý
                </CButton>
                <CButton color="secondary" @click="resetData()"><i class="fa fa-eraser"></i>&nbsp;Làm mới</CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";

export default {
  name: 'UserManual',
  components: {ModalConfirm, BaseTable, BaseFormLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/user_manual/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "HDSD", that.generateViewLevel(that.actionData.model.level));
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.id};
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa HDSD " + that.generateViewLevel(that.actionData.model.level) + " thành công"});
        that.loadDataMainTable();
      }
    });
    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          id: null,
          level: null,
        }
      },
      loading: {value: false},
      mainTable: {
        options: {
          noPaging: true,
          fields: [],
          slots: [
            "index", "createDate", "action", "url", "level", "videoUrl"
          ],
        },
        dataSource: {
          url: "/user_manual/getManual",
          dataSubmit: function () {
            return;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          resultListAttrName: "results"
        },
      },
      fileManuals: [
        {
          selectedFiles: {
            options: {
              label: 'Tệp tin dạng PDF',
              accept: 'application/pdf'
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          selectedFilesVideo: {
            options: {
              label: 'Tệp tin dạng Video',
              accept: '.mp4',
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          level: 0,
          label: 'HDSD cấp Tỉnh'
        },
        {
          selectedFiles: {
            options: {
              label: 'Tệp tin dạng PDF',
              accept: 'application/pdf'
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          selectedFilesVideo: {
            options: {
              label: 'Tệp tin dạng Video',
              accept: '.mp4',
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          level: 1,
          label: 'HDSD cấp Quận/Huyện'
        },
        {
          selectedFiles: {
            options: {
              label: 'Tệp tin dạng PDF',
              accept: 'application/pdf'
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          selectedFilesVideo: {
            options: {
              label: 'Tệp tin dạng Video',
              accept: '.mp4',
            },
            data: {
              loading: false,
              model: {
                fileName: 'Chọn tệp',
                content: '',
                size: '',
                type: ''
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  this.isValid = that.validateFile();
                  return this.isValid;
                }
              }
            }
          },
          level: 2,
          label: 'HDSD cấp Phường/Xã'
        }
      ],
      isDisableSubmit: false
    }
  },
  created() {
  },
  mounted() {
    if (this.$hasAuthor("ROLE_ADMIN")) {
      this.mainTable.options.fields = [
        {key: "index", label: "STT", sorter: false, filter: false},
        {key: "createDate", label: "Ngày tạo"},
        {key: "level", label: "Cấp địa bàn"},
        {key: "url", label: "Tệp tin PDF", sorter: false, filter: false},
        {key: "videoUrl", label: "Tệp tin Video", sorter: false, filter: false},
        {key: "action", label: "Thao tác", sorter: false, filter: false},
      ]
    } else {
      this.mainTable.options.fields = [
        // {key: "index", label: "STT", sorter: false, filter: false},
        {key: "createDate", label: "Ngày tạo"},
        {key: "url", label: "Tệp tin PDF", sorter: false, filter: false},
        {key: "videoUrl", label: "Tệp tin Video", sorter: false, filter: false},
      ]
    }
  },
  methods: {
    async downloadFile(url) {
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    loadDataMainTable() {
      this.$refs.mainTable.loadData();
    },
    generateViewLevel(level) {
      var res = "Cấp Tỉnh";
      if (level == 1) {
        res = "Cấp Quận/Huyện";
      } else if (level == 2) {
        res = "Cấp Phường/Xã";
      }
      return res;
    },
    setupSelectOneAction: function (actionTypeKey, id, level) {
      let actionData = this.actionData.model;
      actionData.id = id;
      actionData.level = level;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    viewFile(url) {
      window.open(url);
    },
    selectFile(event, level, type) {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (type === 1) {
        file = this.$refs.fileVideo;
      }
      if (file && file[level].files[0]) {
        file = file[level].files[0];
        if (type == 0) {
          this.fileManuals[level].selectedFiles.data.loading = true;
        } else {
          this.fileManuals[level].selectedFilesVideo.data.loading = true;
        }
        reader.readAsDataURL(file);

        reader.onload = function () {
          that.isDisableSubmit = false;
          if (type === 0) {
            that.validateFile(file.type, file.size, level);
            that.fileManuals[level].selectedFiles.data.model.size = file.size;
            that.fileManuals[level].selectedFiles.data.model.fileName = file.name;
            that.fileManuals[level].selectedFiles.data.model.type = file.type;
            that.fileManuals[level].selectedFiles.data.model.content = reader.result;
          } else {
            that.validateFileType(file.type, level, type);
            that.fileManuals[level].selectedFilesVideo.data.model.size = file.size;
            that.fileManuals[level].selectedFilesVideo.data.model.fileName = file.name;
            that.fileManuals[level].selectedFilesVideo.data.model.type = file.type;
            that.fileManuals[level].selectedFilesVideo.data.model.content = reader.result;
          }
        }
        reader.onloadend = function () {
          if (type == 0) {
            that.fileManuals[level].selectedFiles.data.loading = false;
          } else {
            that.fileManuals[level].selectedFilesVideo.data.loading = false;
          }
        }
      }
    },
    validateFile(type, size, index) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, index, 0);
      } else {
        if (this.fileManuals[index].selectedFiles.data.model.type && this.fileManuals[index].selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.fileManuals[index].selectedFiles.data.model.type, this.fileManuals[index].selectedFiles.data.model.size, 0);
        } else {
          if (this.fileManuals[index].selectedFiles.data.model.type === '') {
            this.fileManuals[index].selectedFiles.data.validator.isValid = false;
            this.fileManuals[index].selectedFiles.data.validator.errorMessage = "Hướng dẫn sử dụng không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type, index, fileManual) {
      let isValid = true;
      if (fileManual == 0) {
        if (type === "application/pdf") {
          this.fileManuals[index].selectedFiles.data.validator.isValid = true;
          this.fileManuals[index].selectedFiles.data.validator.errorMessage = "";
        } else {
          this.fileManuals[index].selectedFiles.data.validator.isValid = false;
          this.fileManuals[index].selectedFiles.data.validator.errorMessage = "Sai định dạng bản tin";
          isValid = false;
        }
      } else {
        if (type === "video/mp4") {
          this.fileManuals[index].selectedFilesVideo.data.validator.isValid = true;
          this.fileManuals[index].selectedFilesVideo.data.validator.errorMessage = "";
        } else {
          this.fileManuals[index].selectedFilesVideo.data.validator.isValid = false;
          this.fileManuals[index].selectedFilesVideo.data.validator.errorMessage = "Sai định dạng bản tin";
        }
      }
      return isValid;
    },
    resetData() {
      for (var each of this.fileManuals) {
        // each.selectedFiles.data.model.fileName = 'Chọn tệp';
        // each.selectedFilesVideo.data.model.fileName = 'Chọn tệp';
        each.selectedFiles.data.loading = false;
        each.selectedFiles.data.validator.isValid = true;
        each.selectedFiles.data.validator.errorMessage = '';
        each.selectedFiles.data.model = {
          fileName: 'Chọn tệp',
          content: '',
          size: '',
          type: ''
        }
        each.selectedFilesVideo.data.loading = false;
        each.selectedFilesVideo.data.validator.isValid = true;
        each.selectedFilesVideo.data.validator.errorMessage = '';
        each.selectedFilesVideo.data.model = {
          fileName: 'Chọn tệp',
          content: '',
          size: '',
          type: ''
        }

        for (var i = 0; i < this.$refs.file.length; i++) {
          this.$refs.file[i].value = null;
        }
        
      }
      this.isDisableSubmit = true;
    },
    submitData() {
      let isValid = false;
      for (var i = 0; i < this.fileManuals.length; i++) {
        isValid = this.validateFile(this.fileManuals[i].selectedFiles.data.model.type, this.fileManuals[i].selectedFiles.data.model.size, i);
        if (isValid) {
          break;
        }
        // if (this.fileManuals[i].selectedFiles.data.model.content !== '') {
        //   isValid = true;
        //   break;
        // }
        // if (this.fileManuals[i].selectedFilesVideo.data.model.content !== '') {
        //   isValid = true;
        //   break;
        // }
      }
      if (!isValid) {
        return;
      }
      let that = this;
      that.loading.value = true;

      let formData = new FormData();
      for (var i = 0; i < that.$refs.file.length; i++) {
        if (that.$refs.file[i].files[0]) {
          formData.append("file" + that.fileManuals[i].level, that.$refs.file[i].files[0]);
        }
        if (that.$refs.fileVideo[i].files[0]) {
          formData.append("fileVideo" + that.fileManuals[i].level, that.$refs.fileVideo[i].files[0]);
        }
        formData.append("level", that.fileManuals[i].level);
      }

      that.$helper.loadDataSource({
        url: "/user_manual/add",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Upload hướng dẫn sử dụng thành công"});
          }
          that.loadDataMainTable();
          that.resetData();
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        }
      });
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

</style>
